<div class="chargepoint-page">
  <app-chargepoint-card [chargepoint]="chargepoint" [hideActions]="true" class="chargepoint-identity sticky"></app-chargepoint-card>
  <mat-card class="chargepoint-quick-actions sticky">
    <mat-card-header>
      <mat-card-title>Quick Actions</mat-card-title>
    </mat-card-header>
    <mat-card-content class="chargepoint-quick-actions-content">
      <button mat-icon-button matTooltip="Inspect json" (click)="jsonViewerService.openJsonViewer(chargepoint)">
        <mat-icon>data_object</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        matTooltip="View logs"
        (click)="showLogsDialog()">
        <mat-icon>article</mat-icon>
      </button>
      <div class="spacer"></div>
      <button mat-icon-button matTooltip="Start transaction" (click)="startTransaction()" [disabled]="chargepoint.status !== 'AVAILABLE'">
        <mat-icon>play_arrow</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Request status" (click)="requestStatus()">
        <mat-icon>network_ping</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-transactions">
    <mat-card-header>
      <mat-card-title>Transactions</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-transactions-list [chargepoint]="chargepoint"></app-transactions-list>
    </mat-card-content>
  </mat-card>
</div>
